<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Reservas de Produtos</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <reserves-filter ref="filter" :active="filterActive" :searching="loading" @onSearch="onSearch"/>

    <div v-if="loading" class="m-t-20"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-if="!loading && infoLabel" class="ui small label m-t-15">
      <i class="info circle icon"></i>{{ infoLabel }}
    </div>

    <div v-if="$store.state.reserves && $store.state.reserves.length > 0" class="animated fadeIn" style="margin-top: 15px;">

      <div class="ui segment" style="padding: 20px !important;">
        <table class="ui very basic celled selectable tablet stackable table">
          <thead class="desktop-only">
            <tr>
              <th>Status</th>
              <th>Unidade</th>
              <th>Reserva</th>
              <th>Data</th>
              <th>Produto</th>
              <th>Cliente</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="reserve in $store.state.reserves" class="clickable" @click="onShowReserve(reserve)">
              <td>
                <span v-if="reserve.isWaiting"><i class="clock yellow icon"></i> Pendente</span>
                <span v-if="reserve.isConfirmed"><i class="check circle green icon"></i> Confirmada</span>
                <span v-if="reserve.isExpired"><i class="exclamation circle icon"></i> Expirada</span>
                <span v-if="reserve.isCanceled"><i class="times red icon"></i> Cancelada</span>
              </td>
              <td><strong class="mobile-only">Unidade: </strong>{{ reserve.balance.branch.name }}</td>
              <td><strong class="mobile-only">Reserva: </strong>{{ reserve.id }}</td>
              <td><strong class="mobile-only">Data: </strong>{{ $formatDate(reserve.date) }}</td>
              <td><strong class="mobile-only">Produto: </strong>{{ reserve.balance.product.description }}</td>
              <td><strong class="mobile-only">Cliente: </strong>{{ reserve.customerName }}</td>
            </tr>                       
          </tbody>
        </table>
      </div>

    </div>

  </div>

</template>

<script>

  import ReservesFilter from "./filter.vue"
  import OppBalanceService from "@/services/opp-balance-service"

  export default {   
    
    data() {
      return {
        loading: false,
        filterActive: true,
      }
    },

    computed: {

      infoLabel() {

        if (!this.$store.state.reserves)
          return ""
        
        let label = ""
        let count = this.$store.state.reserves.length

        if (count == 0) {

          label = "Nenhum registro encontrado"
        
        } else if (count == 1) {

          label = "1 registro encontrado"

        } else {

          label = count + " registros encontrados"
        }

        return label
      },
    },
    
    components: {
      ReservesFilter,
    },

    created() {

      if (this.$store.state.reserves && this.$store.state.reserves.length > 0)
        this.filterActive = false
    },

    methods: {

      async onSearch(filter) {

        if (this.loading)
          return
        
        this.loading = true

        try {

          const reserves = await OppBalanceService.searchReserves(filter)

          this.$store.commit("setReserves", reserves)

          this.loading = false

          if (reserves.length > 0) {
            this.$refs.filter.toggleActive()
            this.$scroll.toTop()
          }  
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onShowReserve(reserve) {
        this.$router.push(`/products/reserves/show/${reserve.balance.branch.id}/${reserve.id}`)
      },
    },
  }

</script>

